// @ts-nocheck
import SceneLayer from "./layer";

export default class SceneLayerMulti extends SceneLayer {
	/**
	 * Vytvoreni multi vrstvy.
	 *
	 * @param  {String|Number} [id] Volitelne ID
	 */
	constructor(scene, itemId, id) {
		super(scene, itemId, id);

		this._layers = [];
	}

	/**
	 * Destruktor.
	 */
	destroy() {
		this._layers.forEach(layer => {
			layer.destroy();
		});

		super.destroy();
	}

	/**
	 * Informace ohledne entity ve scene.
	 *
	 * @return {Object}
	 */
	// eslint-disable-next-line class-methods-use-this
	get featureInfo() {
		return {
			name: "SceneLayerMulti",
			type: "layer",
		};
	}

	/**
	 * Souhrn vsech dat, ktere vyuziva visualiser pri vytvoreni.
	 *
	 * @return {Object}
	 */
	getCreateData() {
		const rd = super.getCreateData();

		rd.layers = this._layers;

		return rd;
	}

	/**
	 * Prekresleni vsech vrstev.
	 *
	 * @param  {Boolean} [full] Plne prekresleni?
	 */
	redraw(full) {
		this._layers.forEach(layer => {
			layer.redraw(full);
		});
	}

	/**
	 * Vycisteni vsech vrstev.
	 */
	clear() {
		this._layers.forEach(layer => {
			layer.clear();
		});
	}

	/**
	 * Smazani vsech entit vsech vrstev.
	 */
	removeAll() {
		this._layers.forEach(layer => {
			layer.removeAll();
		});
	}

	/**
	 * Povoleni vsech vrstev.
	 */
	enable() {
		if (this._active) {
			return;
		}

		this._layers.forEach(layer => {
			layer.appended = true;

			layer.enable();
		});

		super.enable();
	}

	/**
	 * Zakazani vsech vrstev.
	 */
	disable() {
		if (!this._active) {
			return;
		}

		this._active = false;

		this._layers.forEach(layer => {
			layer.disable();
		});

		super.disable();
	}

	/**
	 * Nastaveni vlastnika vsech vrstev.
	 *
	 * @param {SceneFeature} owner
	 */
	setOwner(owner) {
		this._layers.forEach(layer => {
			layer.appended = !!owner;
		});

		super.setOwner(owner);
	}

	/**
	 * Pridani vrstvy.
	 */
	addLayer(...args) {
		const layer = args[0];

		// vytvorime vrstvu -> pokud jiz je vytvorena, tak preskocime
		this._onChange(this._scene.featureEvent("createLayer", true), [layer]);

		this._layers.push(layer);
		layer.sceneOwner = this;

		if (this.appended) {
			layer.appended = true;
		}
		if (this._active) {
			layer.enable();
		}

		this._onChange(this._scene.featureEvent("layerMultiAddLayer", true, true), args);
	}

	/**
	 * Odebrani vrstvy.
	 *
	 * @return {SceneLayer}
	 */
	removeLayer(...args) {
		const layer = args[0];
		const ind = this._layers.indexOf(layer);

		if (ind === -1) {
			return;
		}

		layer.appended = false;
		layer.sceneOwner = null;

		layer.destroy();

		this._layers.splice(ind, 1);

		this._onChange(this._scene.featureEvent("layerMultiRemoveLayer", true, true), args);
	}

	/**
	 * Ziskani seznamu vsech vrstev.
	 *
	 * @return {Array[SceneLayer]}
	 */
	getLayers() {
		return this._layers;
	}
}
